/* eslint-disable */
import { connect } from 'react-redux';
import { useState, useMemo, useEffect } from 'react';
import { formActions, modalActions } from '../../../Actions';
import { BaseModal } from '../BaseModal';
import { notificationServices } from '../../../Services';
import { ListModal } from '../ListModal';
import StepWiseActionComponent from '../../StepWiseActionComponent/StepWiseActionComponent';
import ProcessAuditStep1 from './ProcessAuditStep1/ProcessAuditStep1';
import ProcessAuditStep2 from './ProcessAuditStep2/ProcessAuditStep2';
import ProcessAuditStep3 from './ProcessAuditStep3/ProcessAuditStep3';
import ProcessAuditStep4 from './ProcessAuditStep4/ProcessAuditStep4';
// eslint-disable-next-line no-unused-vars
import styles from './ProcessAuditCreationModal.module.scss';

const ProcessAuditCreationModal = (props) => {
	const {
		show,
		toggleModal,
		data,
		handleConfirm,
		productCategoriesList,
		productSubCategoriesList,
		productsList,
		stores,
		toggleListModal,
		fetchStoresList,
		fetchProductCategoriesList,
		fetchProductSubCategoriesList,
		permittedStores,
	} = props;

	const { heading = 'Create New Process Audit' } = data || {};

	const initialState = {
		auditName: '',
		storeId: null,
		processId: null,
		selectedProductList: [],
		selectedCategories: [],
		selectedSubCategories: [],
		selectedSkus: [],
		isAllProduct: false,
	};

	const [state, setState] = useState(initialState);

	const handleClose = () => {
		toggleModal(false);
		setState(initialState);
	};

	useEffect(() => {
		if (show) {
			fetchStoresList({
				entity: 'STORES',
				req: { params: { id: '' } },
				method: 'LIST',
			});
			fetchProductCategoriesList({
				entity: 'PRODUCT_CATEGORY',
				req: { params: { id: '' } },
				method: 'LIST',
			});
			fetchProductSubCategoriesList({
				entity: 'PRODUCT_SUB_CATEGORY',
				req: { params: { id: '' } },
				method: 'LIST',
			});
		}
	}, [show]);

	// All enabled products (QR and Non-QR). The QR / Non-QR / ALL toggle lives in AuditStep4.
	const enabledProductsList = useMemo(() => {
		return (productsList ?? []).filter((p) => p?.isEnabled);
	}, [productsList]);

	const PRODUCTS = useMemo(() => {
		return enabledProductsList.map((p) => ({ id: p.id, title: p?.productName ?? '' }));
	}, [enabledProductsList]);

	const skusList = useMemo(() => {
		const seen = new Set();
		enabledProductsList.forEach((p) => {
			if (p?.skuType) seen.add(p.skuType);
		});
		return Array.from(seen);
	}, [enabledProductsList]);

	const setStateField = (field) => (value) => {
		setState((prev) => ({ ...prev, [field]: value }));
	};

	const setSelectedSkyTypes = (value) => {
		setState((prev) => ({ ...prev, selectedSkus: value }));
	};

	const deleteFilter = (e) => {
		const dataset = e?.target?.dataset || e?.currentTarget?.dataset;
		if (!dataset) return;
		const { id, entity } = dataset;
		if (entity === 'PRODUCT') {
			setState((prev) => ({
				...prev,
				selectedProductList: prev.selectedProductList.filter((x) => x !== parseInt(id, 10)),
			}));
		}
		if (entity === 'CATEGORY') {
			setState((prev) => ({
				...prev,
				selectedCategories: prev.selectedCategories.filter((x) => x !== parseInt(id, 10)),
			}));
		}
		if (entity === 'SUB_CATEGORY') {
			setState((prev) => ({
				...prev,
				selectedSubCategories: prev.selectedSubCategories.filter((x) => x !== parseInt(id, 10)),
			}));
		}
	};

	const addFilter = (filters, context) => {
		if (context.entity === 'PRODUCT') {
			setState((prev) => ({
				...prev,
				selectedProductList: [...prev.selectedProductList, ...filters],
			}));
		}
		if (context.entity === 'CATEGORY') {
			setState((prev) => ({
				...prev,
				selectedSubCategories: [],
				selectedCategories: [...prev.selectedCategories, ...filters],
			}));
		}
		if (context.entity === 'SUB_CATEGORY') {
			setState((prev) => ({
				...prev,
				selectedCategories: [],
				selectedSubCategories: [...prev.selectedSubCategories, ...filters],
			}));
		}
	};

	const handleSetNewProductList = (list) => {
		setState((prev) => ({ ...prev, selectedProductList: list }));
	};

	const handleRemoveAllProducts = () => {
		setState((prev) => ({ ...prev, selectedProductList: [] }));
	};

	const handleCreate = () => {
		const auditProductsList = [...state.selectedProductList];
		handleConfirm({
			...state,
			productsList: auditProductsList,
			isAllProduct: enabledProductsList.length === auditProductsList.length,
			productSelection: {
				selectedSkus: state.selectedSkus,
				selectedCategories: (state.selectedCategories || []).map((cid) => {
					const c = (productCategoriesList || []).find((e) => e.id === cid);
					return { id: c?.id, productCategoryName: c?.productCategoryName };
				}),
				selectedSubCategories: (state.selectedSubCategories || []).map((sid) => {
					const s = (productSubCategoriesList || []).find((e) => e.id === sid);
					return { id: s?.id, name: s?.name };
				}),
			},
		});
	};

	const steps = [
		{
			stepHeader: 'Audit Name',
			showBack: true,
			backBtnTxt: 'Cancel',
			showNext: true,
			onBack: (_, cb) => { handleClose(); cb(); },
			onNext: (_, cb) => {
				if (!state.auditName) {
					notificationServices.generateNotification({
						type: 'error',
						message: 'Please enter Audit name',
					});
					return;
				}
				cb();
			},
			renderComponent: (currentStep) => (
				<ProcessAuditStep1
					auditName={state.auditName}
					setAuditName={setStateField('auditName')}
					scheduledFor={null}
					setScheduledFor={() => {}}
					currentStep={currentStep}
					show={show}
				/>
			),
		},
		{
			stepHeader: 'Store & Process',
			showBack: true,
			showNext: true,
			onBack: (_, cb) => cb(),
			onNext: (_, cb) => {
				if (!state.storeId || !state.processId) {
					notificationServices.generateNotification({
						type: 'error',
						message: 'Please select a store and a process',
					});
					return;
				}
				cb();
			},
			renderComponent: () => (
				<ProcessAuditStep2
					stores={stores}
					permittedStores={permittedStores}
					selectedStoreId={state.storeId}
					selectedProcessId={state.processId}
					setSelectedStoreId={setStateField('storeId')}
					setSelectedProcessId={setStateField('processId')}
				/>
			),
		},
		{
			stepHeader: 'SKU Type & Category & Sub Category',
			showBack: true,
			showNext: true,
			onBack: (_, cb) => cb(),
			onNext: (_, cb) => {
				setState((prev) => {
					const selectedProductList = enabledProductsList
						.filter((ele) => {
							if (!ele?.isEnabled) return false;
							const hasSku = prev.selectedSkus?.length > 0;
							const hasCat = prev.selectedCategories?.length > 0;
							const hasSub = prev.selectedSubCategories?.length > 0;
							if (!hasSku && !hasCat && !hasSub) return true;
							const matchSku = !hasSku || prev.selectedSkus.includes(ele.skuType);
							const matchCat = !hasCat || prev.selectedCategories.includes(ele.categoryId);
							const matchSub = !hasSub || prev.selectedSubCategories.includes(ele.subCategoryId);
							if (hasCat) return matchCat && matchSku;
							return matchSub && matchSku;
						})
						.map((e) => e.id);
					return { ...prev, selectedProductList };
				});
				cb();
			},
			renderComponent: () => (
				<ProcessAuditStep3
					skusList={skusList}
					deleteFilter={deleteFilter}
					selectedSkus={state.selectedSkus}
					setSelectedSkyTypes={setSelectedSkyTypes}
					toggleListModal={toggleListModal}
					productCategoriesList={productCategoriesList}
					productSubCategoriesList={productSubCategoriesList}
					selectedCategories={state.selectedCategories}
					selectedSubCategories={state.selectedSubCategories}
				/>
			),
		},
		{
			stepHeader: 'Product & Verify',
			showBack: true,
			showNext: true,
			nextBtnTxt: 'Confirm',
			onBack: (_, cb) => {
				if (state.selectedProductList.length) {
					setState({ ...state, selectedProductList: [] });
				}
				cb();
			},
			onNext: () => {
				if (!state.selectedProductList.length) {
					notificationServices.generateNotification({
						type: 'error',
						message: 'No product selected',
					});
					return;
				}
				handleCreate();
			},
			renderComponent: () => (
				<ProcessAuditStep4
					skusList={skusList}
					selectedSkus={state.selectedSkus}
					toggleListModal={toggleListModal}
					productCategoriesList={productCategoriesList}
					productSubCategoriesList={productSubCategoriesList}
					productsList={enabledProductsList}
					selectedCategories={state.selectedCategories}
					selectedSubCategories={state.selectedSubCategories}
					handleSetNewProductList={handleSetNewProductList}
					deleteFilter={deleteFilter}
					auditCreationState={state}
					selectedProducts={state.selectedProductList}
					handleRemoveAllProducts={handleRemoveAllProducts}
				/>
			),
		},
	];

	return (
		<BaseModal
			customStyles={{ width: '75%', height: '45rem' }}
			modalCallee='processAuditCreator'
			heading={heading}
			open={show}
			handleClose={handleClose}
			hideFooter
		>
			<ListModal handleConfirm={addFilter} list={PRODUCTS} />
			<StepWiseActionComponent steps={steps} />
		</BaseModal>
	);
};

const mapStateToProps = (state) => {
	const stores = state?.form?.STORES?.data?.LIST;
	const { permittedStores } = state?.navigation;
	const modalSlice = state?.modal?.processAuditCreationModal || { show: false, data: {} };
	const { show, data } = modalSlice;
	const { LIST: productCategoriesList } = state.form.PRODUCT_CATEGORY.data;
	const { LIST: productSubCategoriesList } = state.form.PRODUCT_SUB_CATEGORY.data;
	const { LIST: productsList } = state.form.ALL_PRODUCTS.data;

	return {
		show,
		data,
		stores,
		productsList,
		productCategoriesList,
		productSubCategoriesList,
		permittedStores,
	};
};

const mapDispatchToProps = {
	toggleModal: modalActions.toggleProcessAuditCreationModal,
	toggleListModal: modalActions.toggleListModal,
	fetchStoresList: formActions.gateway,
	fetchProductCategoriesList: formActions.gateway,
	fetchProductSubCategoriesList: formActions.gateway,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProcessAuditCreationModal);
